// Helpers
import { ROLE_ADMIN, ROLE_THERAPIST, ROLE_THERAPIST_ADMIN, ROLE_USER } from "./constants";

/**
 * All routes in the app.
 */
export const ROUTES = {
    dashboard: "/",
    activities: "/aktivitaeten",
    activitiesManagement: "/aktivitaetenverwaltung",
    admins: "/admins",
    calendar: "/kalender",
    login: "/login",
    newPassword: "/neues-passwort",
    onboarding: "/onboarding",
    resetPassword: "/passwort-vergessen",
    signup: "/anmeldung",
    therapists: "/therapeuten",
    therapistsList: "/therapeuten/liste",
    therapistsCalendar: "/therapeuten/kalender",
    therapists_patients: "/patienten",
    userUploads: "/dateien-hochladen",
    users: "/benutzer",
    courses: "/videokurs",
    community: "/community",
    user: {
        settings: "/user/einstellungen",
        reports: "/user/berichte"
    },

    legal: {
        termsConditions: "/rechtliches/agb",
        dataProtection: "/rechtliches/datenschutz",
        imprint: "/rechtliches/impressum"
    }
};

/**
 * Fallback routes for each role.
 */
export const FALLBACK_ROUTES_BY_ROLE = {
    [ROLE_ADMIN]: ROUTES.users,
    [ROLE_THERAPIST]: ROUTES.therapists_patients,
    [ROLE_THERAPIST_ADMIN]: ROUTES.therapists_patients,
    [ROLE_USER]: ROUTES.dashboard
};

/**
 * API routes.
 */
export const API_ROUTES = {
    patient: {
        feedback: "/patient/feedback",
        substitutes: {
            postpone: (userId: string) => `/patient/${userId}/substitutes/postpone`,
            pendingEvents: (userId: string, substituteId: string) =>
                `/patient/${userId}/substitutes/${substituteId}/pending-events`
        }
    },
    admin: {
        user: {
            activeTherapySubscription: "/admin/user/[id]/activeTherapySubscription"
        }
    }
};
